import { isMobile } from 'react-device-detect';

const getPageUrl = (language, state) => {
    const pageUrl = new URL(process.env.REACT_APP_API_HOST);
    pageUrl.searchParams.set('lang', language);
    if (state) {
        pageUrl.searchParams.set('state', state);
    }

    return pageUrl.toString();
};

const getLinkedInShareUrl = (language, state) =>
    `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
        getPageUrl(language, state),
    )}`;

const getLinkedInAppUrl = (language, state) =>
    `linkedin://shareArticle?mini=true&url=${encodeURIComponent(
        getPageUrl(language, state),
    )}`;

// LinkedIn's web share link always opens a browser, even on a phone with the
// LinkedIn app installed. To land in the app instead, we try its custom URL
// scheme first and fall back to the web share URL if the app doesn't take
// over the page (e.g. it isn't installed).
const openLinkedInShare = (language, state) => {
    const webUrl = getLinkedInShareUrl(language, state);

    if (!isMobile) {
        window.open(webUrl, '_blank', 'noopener,noreferrer');
        return;
    }

    let appOpened = false;
    const onVisibilityChange = () => {
        if (document.hidden) {
            appOpened = true;
        }
    };
    document.addEventListener('visibilitychange', onVisibilityChange);

    setTimeout(() => {
        document.removeEventListener('visibilitychange', onVisibilityChange);
        if (!appOpened) {
            window.location.href = webUrl;
        }
    }, 1500);

    window.location.href = getLinkedInAppUrl(language, state);
};

export default openLinkedInShare;
